import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.common.white,
        "& > *": {
            maxWidth: "500px",
            borderRadius: ".375rem",
            padding: theme.spacing(2),
            gap: theme.spacing(2),
            display: "flex",
            alignItems: "center",
            margin: "0 auto",
            [theme.breakpoints.down("xs")]: {
                margin: "unset",
            },
        },
    },
    icon: {
        height: "60px",
        width: "60px",
        color: "#d1d5db",
        flexShrink: 0,
        [theme.breakpoints.down("xs")]: {
            height: "40px",
            width: "40px",
        },
    },
    fullWidth: {
        width: "100%",
    },
    loader: {
        height: "16px",
        backgroundColor: "#e5e7eb",
        borderRadius: ".375rem",
        marginTop: "8px",
        display: "block",
        width: "100%%",
        [theme.breakpoints.down("xs")]: {
            display: "none",
        },
    },
    twoThird: {
        width: "66.6%",
    },
}));
